import axios from 'axios';
import createAuthRefreshInterceptor from './createAuthRefreshInterceptor';
import authAxios from './authAxios';
import env from '../env-config';

console.log("env.REACT_APP_API_BASE_URL : " + env.REACT_APP_API_BASE_URL);

const appAxios = axios.create({
    baseURL: env.REACT_APP_API_BASE_URL,
});

function getAccessToken() {
    return localStorage.getItem('SCGChem.PMM.WasteMgnt.WebUI.token');
}

appAxios.interceptors.request.use(request => {
    request.headers['Authorization'] = 'Bearer ' + getAccessToken();
    return request;
});

// Function that will be called to refresh authorization
//const refreshAuthLogic = failedRequest => authAxios.get("/auth/token").then((tokenRefreshResponse) => {
//    localStorage.setItem('SCGChem.PMM.WasteMgnt.WebUI.token', tokenRefreshResponse.data.access_token);
//    failedRequest.response.config.headers['Authorization'] = 'Bearer ' + tokenRefreshResponse.data.access_token;
//    return Promise.resolve();

//}, (tokenRefreshErr) => {
//    sessionStorage.setItem("SCGChem.PMM.WasteMgnt.WebUI.RedirectUrl", window.location.href);
//    window.location = env.REACT_APP_API_BASE_URL + "/auth";
//});

// Instantiate the interceptor (you can chain it as it returns the axios instance)
//createAuthRefreshInterceptor(appAxios, refreshAuthLogic);
createAuthRefreshInterceptor(appAxios);

export default appAxios;
